import { isLoginJWT } from "../../Utils/jwtUtils";

const initialState = {
  user: isLoginJWT().user,
  isLogin: false,
  azureToken: "",
  position: "",
};
export const userReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case "@user/login":
      return {
        ...state,
        user: action.payload.user,
        position: action.payload.position,
        azureToken: action.payload.token,
        isLogin: true,
      };
    case "@user/update":
      return { ...state, user: action.payload.user };
    case "@user/logout":
      return { ...state, user: {}, isLogin: false, azureToken: "" };
    default:
      return state;
  }
};
